exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span img[_v-4b171b64]{height:24px;margin:5px}.mdl-spinner[_v-4b171b64]{margin:0 5px;height:20px;width:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4b171b64&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/components/Attachment.vue
// module id = 306
// module chunks = 0